// Ad Conversion Tracker
const AdConversionTracker = {
  // Configuration
  config: {
    sessionDuration: 30000, // 30 seconds
    conversionPath: "corporate-gifting-success",
    trackingPath: "corporate-christmas-gifting",
    sessionKey: "adConversionTrackingSession",
    sessionExpiresKey: "adConversionSessionExpiresAt",
    clickableClass: "shopify-app-block",
    conversionId: "AW-11083930444/Od0vCM7YzdMZEMy2naUp",
  },

  // State
  state: {
    sessionTimer: null,
  },

  // Initialization method
  init() {
    if (this.isTrackingPage()) {
      console
      this.setupEventListeners();
      this.checkSessionExpiry();
    } else if (this.isConversionPage()) {
      this.checkAdConversionSession();
    }
  },

  // Check if current page is the tracking page
  isTrackingPage() {
    return window.location.pathname.includes(this.config.trackingPath);
  },

  // Check if current page is the conversion page
  isConversionPage() {
    return window.location.pathname.includes(this.config.conversionPath);
  },

  // Set up event listeners
  setupEventListeners() {
    document.addEventListener("click", this.handleClick.bind(this));
  },

  // Handle click events
  handleClick(event) {
    if (event.target.closest(`.${this.config.clickableClass}`)) {
      this.startSession();
    }
  },

  // Start or refresh the session
  startSession() {
    sessionStorage.setItem(this.config.sessionKey, "true");
    sessionStorage.setItem(
      this.config.sessionExpiresKey,
      Date.now() + this.config.sessionDuration
    );

    clearTimeout(this.state.sessionTimer);
    this.state.sessionTimer = setTimeout(() => {
      this.clearSession();
    }, this.config.sessionDuration);

    console.log("Session started/refreshed");
  },

  // Clear the session
  clearSession() {
    sessionStorage.removeItem(this.config.sessionKey);
    sessionStorage.removeItem(this.config.sessionExpiresKey);
    console.log("Session cleared");
  },

  // Check and clean expired sessions
  checkSessionExpiry() {
    const expiresAt = sessionStorage.getItem(this.config.sessionExpiresKey);
    if (expiresAt && Date.now() > parseInt(expiresAt, 10)) {
      this.clearSession();
    }
  },

  // Check for active ad conversion session
  checkAdConversionSession() {
    const sessionExists = sessionStorage.getItem(this.config.sessionKey);
    const sessionExpiresAt = sessionStorage.getItem(
      this.config.sessionExpiresKey
    );

    if (
      sessionExists &&
      sessionExpiresAt &&
      Date.now() < parseInt(sessionExpiresAt, 10)
    ) {
      this.trackAdConversion();
      
      this.clearSession();
    } else {
      console.log(
        "No active ad conversion tracking session found or session has expired."
      );
    }
  },

  // Track Google Ads conversion
  trackAdConversion() {
    if (typeof gtag === "function") {
      gtag("event", "conversion", { 'send_to': this.config.conversionId });
      console.log("Ad conversion tracked successfully");
    } else {
      console.error("Google Ads gtag function not found");
    }
  },
};

// Initialize the tracker when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  AdConversionTracker.init();
});
